import { BookmarkBorder } from '@mui/icons-material'
import { SvgIconProps } from '@mui/material'
import React from 'react'

const TodoIcon = ({ iconColor, ...iconProps }: SvgIconProps & { iconColor?: string }) => (
  <BookmarkBorder
    fontSize="large"
    {...iconProps}
    sx={{
      fill: iconColor,
      ...iconProps.sx
    }}
  />
)

export default TodoIcon
